import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f8211c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headerChil" }
const _hoisted_2 = {
  key: 0,
  style: {"float":"left","margin-left":"40px"}
}
const _hoisted_3 = {
  key: 0,
  class: "count"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "委托书-待审核：", -1))
const _hoisted_5 = { style: {"color":"#f56c6c"} }
const _hoisted_6 = {
  key: 1,
  class: "count"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "委托书-执行中：", -1))
const _hoisted_8 = { style: {"color":"#f56c6c"} }
const _hoisted_9 = {
  key: 2,
  class: "count"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单-执行中：", -1))
const _hoisted_11 = { style: {"color":"#f56c6c"} }
const _hoisted_12 = {
  key: 3,
  class: "count"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "拼单配载-待配载：", -1))
const _hoisted_14 = { style: {"color":"#f56c6c"} }
const _hoisted_15 = {
  key: 4,
  class: "count"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "出入库管理-待调整：", -1))
const _hoisted_17 = { style: {"color":"#f56c6c"} }
const _hoisted_18 = { class: "containerSub" }
const _hoisted_19 = { class: "el-dropdown-link link" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_badge = _resolveComponent("el-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.path == '/')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.powers.contains('OrderManagement_Pool'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.WaitingAudit), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.powers.contains('OrderManagement_Pool'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.PoolExecuting), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.powers.contains('OrderManagement_Order'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.OrderExecuting), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.powers.contains('OrderStowageStack'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.WaitingStowage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.powers.contains('InbounDoutbound'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.InboundoutboundAdjust), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["list", item.Id == _ctx.activeTwo ? 'activeTwo' : '']),
          key: index
        }, [
          (item.Children && item.Children?.length > 0)
            ? (_openBlock(), _createBlock(_component_el_dropdown, {
                key: 0,
                class: "divName"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Children, (it, i) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: i,
                          onClick: ($event: any) => (_ctx.HandleMenuChil(it, item))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(it.Id == _ctx.activeThree ? 'activeThree' : '')
                            }, _toDisplayString(it.Name), 3)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(item.Name) + " ", 1),
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "divName",
                onClick: ($event: any) => (_ctx.HandleMenu(item))
              }, [
                (_ctx.redCodes?.findIndex((it) => it == item.Code) != -1)
                  ? (_openBlock(), _createBlock(_component_el_badge, {
                      key: 0,
                      "is-dot": "",
                      class: "item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.Name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.Name), 1))
              ], 8, _hoisted_20))
        ], 2))
      }), 128))
    ])
  ]))
}